<app-theme-handler />
<div
  class="rds-body rds-display-flex rds-flex-column rds-justify-content-between app-container rds-body-color-background-subtle">
  <app-header></app-header>
  <div class="spacer"></div>
  <div class="rds-flex-grow-1">
    <app-toastr></app-toastr>
    <router-outlet></router-outlet>
  </div>
  <div class="spacer"></div>
  <app-footer></app-footer>
</div>
